import { render, staticRenderFns } from "./WindowManager.vue?vue&type=template&id=1d178035"
import script from "./WindowManager.vue?vue&type=script&lang=js"
export * from "./WindowManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports